import { X } from 'lucide-react';

function variantClass(variant) {
  switch (variant) {
    case 'success':
      return 'toast toast-success';
    case 'error':
      return 'toast toast-error';
    case 'warning':
      return 'toast toast-warning';
    default:
      return 'toast toast-info';
  }
}

export default function ToastContainer({ toasts, onDismiss }) {
  if (!toasts.length) {
    return null;
  }

  return (
    <div className="toast-container" role="region" aria-live="polite" aria-label="Уведомления">
      {toasts.map((toast) => (
        <div key={toast.id} className={variantClass(toast.variant)}>
          <span>{toast.message}</span>
          <button
            type="button"
            className="toast-close"
            onClick={() => onDismiss(toast.id)}
            aria-label="Закрыть уведомление"
          >
            <X size={16} aria-hidden="true" />
          </button>
        </div>
      ))}
    </div>
  );
}
